import { render, staticRenderFns } from "./ManualForm.vue?vue&type=template&id=f3baf190&scoped=true&lang=pug&"
import script from "./ManualForm.vue?vue&type=script&lang=ts&"
export * from "./ManualForm.vue?vue&type=script&lang=ts&"
import style0 from "./ManualForm.vue?vue&type=style&index=0&id=f3baf190&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3baf190",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
